import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    Chip,
    useTheme,
    useMediaQuery,
    ButtonGroup,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Grid,
    CircularProgress,
    Tabs,
    Tab,
    Autocomplete,
    Menu,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import {
    Close as CloseIcon,
    Add as AddIcon,
    Person as PersonIcon,
    CalendarMonth as CalendarIcon,
    Event as EventIcon,
    AccountCircle as AccountCircleIcon,
    DragIndicator as DragIcon,
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
    TableChart as TableIcon,
    ViewModule as KanbanIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    Polyline as PolylineIcon,
    ManageAccounts as ManageAccountsIcon,
    SupervisorAccount as SupervisorAccountIcon,
    Delete as DeleteIcon,
    Warning as WarningIcon,
    Sync as SyncIcon,
    ElectricalServices as TowerIcon,
    AccountTree as AccountTreeIcon,
    ExpandMore as ExpandMoreIcon,
    Archive as ArchiveIcon,
    Clear as ClearIcon,
    LocationOn as LocationIcon
} from '@mui/icons-material';


export const SpecsViewDialog = ({
    currentTaskSpecs,
    currentTaskFullSpecs,
    specs,
    getObjectName,
    getLayerName,
    handleDialogClose,
    darkMode,
    isMobile,
}) => {
    return (
        <Dialog
            open={true}
            onClose={handleDialogClose}
            // onClose={() => {
            //     setSpecsDialogOpen(false);
            //     setCurrentTaskSpecs(null);
            // }}
            maxWidth="lg"
            fullWidth
            fullScreen={isMobile}
            sx={{ zIndex: 6500 }}
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                        color: darkMode ? '#f5f7fa' : '#333',
                        borderRadius: isMobile ? 0 : 3,
                        boxShadow: darkMode
                            ? '0 8px 32px rgba(0, 0, 0, 0.4)'
                            : '0 8px 32px rgba(0, 0, 0, 0.12)',
                    }
                }
            }}
        >
            <DialogTitle sx={{
                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                borderBottom: darkMode
                    ? '1px solid rgba(255, 255, 255, 0.12)'
                    : '1px solid rgba(0, 0, 0, 0.12)',
                px: 3,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        bgcolor: 'rgba(156, 39, 176, 0.1)',
                        border: '2px solid #9c27b0'
                    }}>
                        <AccountTreeIcon sx={{
                            fontSize: '24px',
                            color: '#9c27b0'
                        }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{
                            fontWeight: 700,
                            color: darkMode ? '#f5f7fa' : '#333'
                        }}>
                            Материалы
                        </Typography>
                        <Typography variant="body2" sx={{
                            color: darkMode ? '#bbb' : '#666',
                            fontSize: '0.875rem'
                        }}>
                            Задача: {currentTaskSpecs?.title || currentTaskSpecs?.name}
                        </Typography>
                    </Box>
                </Box>

                <IconButton
                    onClick={handleDialogClose}
                    // onClick={() => {
                    //     setSpecsDialogOpen(false);
                    //     setCurrentTaskSpecs(null);
                    // }}
                    size="large"
                    sx={{
                        color: darkMode ? '#f5f7fa' : '#666',
                        '&:hover': {
                            bgcolor: 'rgba(244, 67, 54, 0.1)',
                            color: '#f44336'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{
                bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                p: 3
            }}>
                {currentTaskSpecs && (
                    <MaterialsViewer
                        task={currentTaskSpecs}
                        taskObjects={currentTaskFullSpecs}
                        getObjectName={getObjectName}
                        getLayerName={getLayerName}
                        specs={specs}
                        // pillars={pillars}
                        // pillarsZvz={pillarsZvz}
                        // pillarsOpn={pillarsOpn}
                        // pillarsRlnd={pillarsRlnd}
                        // fiders={fiders}
                        // specs={specs}
                        darkMode={darkMode}
                    />
                )}
            </DialogContent>

            <DialogActions sx={{
                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                borderTop: darkMode
                    ? '1px solid rgba(255, 255, 255, 0.12)'
                    : '1px solid rgba(0, 0, 0, 0.12)',
                py: 2,
                px: 3
            }}>
                <Button
                    onClick={handleDialogClose}
                    // onClick={() => {
                    //     setSpecsDialogOpen(false);
                    //     setCurrentTaskSpecs(null);
                    // }}
                    variant="outlined"
                    sx={{
                        color: darkMode ? '#bbb' : '#666',
                        borderColor: darkMode ? '#555' : '#ddd',
                        '&:hover': {
                            borderColor: darkMode ? '#777' : '#bbb',
                            bgcolor: 'transparent'
                        }
                    }}
                >
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    )
}

// Компонент просмотра материалов
const MaterialsViewer = ({ task, taskObjects, getObjectName, getLayerName, specs, darkMode }) => {
    const [tabValue, setTabValue] = useState(0);



    // Базовый вид - объединяем все материалы первого уровня
    const consolidatedMaterials = useMemo(() => {
        const materials = new Map();

        if (!task.data.objects) return [];

        Object.keys(task.data.objects).forEach(type => {
            if (!taskObjects[type]) return;
            taskObjects[type].forEach(obj => {

                if (!obj.spec) return;
                let spec = null;
                if (type === 'fiders') {
                    spec = Array.isArray(obj.specs) && obj.specs.length > 0 ? obj.specs.map(s => specs[s]) : [specs[obj.spec]]

                    spec.filter(Boolean).map((_spec, i) => {
                            // Особая обработка для фидеров - берем спецификацию провода и вычисляем длину
                            if (_spec.name && obj.chains && obj.distance) {
                                const totalLength = obj.chains[i] * obj.distance;

                                const key = `${spec.name}_fider_cable`;

                                if (materials.has(key)) {
                                    const existing = materials.get(key);
                                    existing.count += totalLength;
                                    existing.objects.add([getObjectName(type, obj), getLayerName(obj.type)]);
                                } else {
                                    materials.set(key, {
                                        name: _spec.name,
                                        type_marka_docs: _spec.type_marka_docs,
                                        factory_manufacturer: _spec.factory_manufacturer,
                                        unit: 'м',
                                        count: totalLength,
                                        mass: 0, // Для проводов массу не считаем
                                        type: _spec.category,
                                        objects: new Set([[getObjectName(type, obj), getLayerName(obj.type)]])
                                    });
                                }
                            }
                        })
                } else {
                    if (obj.spec_complect) {
                        spec = specs[obj.spec]?.[Number(obj.spec_complect)]
                    } else {
                        spec = Object.values(specs[obj.spec])[0]
                    }
                    function complectProcessing(level, typeName, complect, parentCount = 1) {
                        complect.forEach(material => {
                            const key = `${material.name}_${material.type_marka_docs}_${material.factory_manufacturer}_${typeName}`;
                            const count = (parseFloat(material.count) * parentCount) || 0;
                            if (materials.has(key)) {
                                const existing = materials.get(key);
                                existing.count += count;
                                existing.mass += (parseFloat(material.massa_1ed_kg) * count) || 0;
                                existing.objects.add([getObjectName(type, obj), getLayerName(obj.type)]);
                            } else {
                                materials.set(key, {
                                    name: material.name,
                                    type_marka_docs: material.type_marka_docs,
                                    factory_manufacturer: material.factory_manufacturer,
                                    unit: material.unit,
                                    count: count,
                                    mass: (parseFloat(material.massa_1ed_kg) * count) || 0,
                                    type: typeName, // Добавляем тип материала из complect_filtered
                                    objects: new Set([[getObjectName(type, obj), getLayerName(obj.type)]])
                                });
                            }
                            if (material.complect) {
                                complectProcessing(level + 1, material.type, material.complect, count);
                            }
                        });

                    }
                    //Стандартная логика для остальных типов объектов
                    if (spec?.complect_filtered) {
                        spec.complect_filtered.forEach(cf => {
                            complectProcessing(0, cf.type, cf.complect);

                        });
                    }



                }
            });
        });

        return Array.from(materials.values());
    }, [taskObjects, getObjectName]);

    // Подсчет уникальных спецификаций
    const specStats = useMemo(() => {
        const specCounts = new Map();

        if (!task.data.objects) return [];

        Object.keys(task.data.objects).forEach(type => {
            if (!taskObjects[type]) return;

            taskObjects[type].forEach(obj => {
                if (!obj.spec) return;
                let spec = null;

                if (type === 'fiders') {
                    // spec = specs[obj.spec]
                    spec = Array.isArray(obj.specs) && obj.specs.length > 0 ? obj.specs.map(s => specs[s]) : [specs[obj.spec]]
                        // console.log(spec?.name, obj.chains, obj.distance)
                    spec.filter(Boolean).map((_spec, i) => {
                            // Для фидеров создаем уникальную запись по проводу
                            if (_spec) {
                                const key = `fider_${_spec.name}`;
                                if (specCounts.has(key)) {
                                    const existing = specCounts.get(key);
                                    existing.count += 1;
                                    existing.objects.push([getObjectName(type, obj), getLayerName(obj.type)]);
                                } else {
                                    specCounts.set(key, {
                                        spec: {
                                            ..._spec,
                                            type: _spec.category
                                        },
                                        typeName: 'Фидер',
                                        count: 1,
                                        objects: [[getObjectName(type, obj), getLayerName(obj.type)]]
                                    });
                                }
                            }
                        })
                } else {
                    if (obj.spec_complect) {
                        spec = specs[obj.spec]?.[Number(obj.spec_complect)]
                    } else {
                        spec = Object.values(specs[obj.spec])[0]
                    }
                    // Стандартная логика для остальных объектов
                    if (spec) {
                        const typeName = type === 'pillars' ? 'Опоры' :
                            type === 'zvz' ? 'ЗВЗ' :
                                type === 'opn' ? 'ОПН' :
                                    type === 'rlnd' ? 'РЛНД' : type;

                        const key = `${obj.spec}_${typeName}`;
                        if (specCounts.has(key)) {
                            const existing = specCounts.get(key);
                            existing.count += 1;
                            existing.objects.push([getObjectName(type, obj), getLayerName(obj.type)]);
                        } else {
                            specCounts.set(key, {
                                spec: { ...spec, id: obj.spec },
                                typeName,
                                count: 1,
                                objects: [[getObjectName(type, obj), getLayerName(obj.type)]]
                            });
                        }
                    }
                }
            });
        });

        return Array.from(specCounts.values());
    }, [taskObjects, getObjectName]);

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={tabValue}
                onChange={(_, newValue) => setTabValue(newValue)}
                sx={{
                    borderBottom: 1,
                    borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
                    mb: 2,
                    '& .MuiTab-root': {
                        color: darkMode ? '#bbb' : '#666',
                        fontWeight: 600,
                        '&.Mui-selected': {
                            color: darkMode ? '#ce93d8' : '#9c27b0'
                        }
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: darkMode ? '#ce93d8' : '#9c27b0'
                    }
                }}
            >
                <Tab label="Заказная спецификация" />
                <Tab label="Комплектная спецификация" />
            </Tabs>

            {/* Базовый вид */}
            {tabValue === 0 && (
                <Box>
                    <Typography variant="h6" sx={{
                        mb: 2,
                        color: darkMode ? '#f5f7fa' : '#333',
                        fontWeight: 600
                    }}>
                        Сводная таблица материалов ({consolidatedMaterials.length} наименований)
                    </Typography>

                    <TableContainer component={Paper} sx={{
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        borderRadius: 2,
                        maxHeight: 500,
                        '& .MuiTableCell-root': {
                            borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
                            color: darkMode ? '#f5f7fa' : '#333'
                        }
                    }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600 }}>
                                        Наименование
                                    </TableCell>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600 }}>
                                        Тип, марка, обозначение
                                    </TableCell>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600 }}>
                                        Завод изготовитель
                                    </TableCell>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600, textAlign: 'center' }}>
                                        Общее количество
                                    </TableCell>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600, textAlign: 'center' }}>
                                        Общая масса, кг
                                    </TableCell>
                                    <TableCell sx={{ bgcolor: darkMode ? '#333' : '#f5f5f5', fontWeight: 600 }}>
                                        Объекты
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(() => {
                                    // Группируем материалы по типам
                                    const groupedMaterials = new Map();

                                    consolidatedMaterials.forEach((material) => {
                                        const materialType = material.type || material.category || 'Прочие';
                                        if (!groupedMaterials.has(materialType)) {
                                            groupedMaterials.set(materialType, []);
                                        }
                                        groupedMaterials.get(materialType).push(material);
                                    });

                                    // Создаем массив строк для отображения
                                    const rows = [];
                                    let rowIndex = 0;

                                    groupedMaterials.forEach((materials, type) => {
                                        // Добавляем заголовок группы
                                        rows.push(
                                            <TableRow key={`header_${rowIndex}`} sx={{
                                                bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)'
                                            }}>
                                                <TableCell colSpan={6} sx={{
                                                    fontWeight: 600,
                                                    fontSize: '0.9rem',
                                                    color: darkMode ? '#ce93d8' : '#9c27b0',
                                                    textAlign: 'center'
                                                }}>
                                                    {type}
                                                </TableCell>
                                            </TableRow>
                                        );
                                        rowIndex++;

                                        // Добавляем материалы этого типа
                                        materials.forEach((material, matIndex) => {
                                            rows.push(
                                                <TableRow key={`material_${rowIndex}_${matIndex}`} sx={{
                                                    '&:hover': {
                                                        bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'
                                                    }
                                                }}>
                                                    <TableCell sx={{ fontWeight: 500 }}>
                                                        {material.name}
                                                    </TableCell>
                                                    <TableCell>
                                                        {material.type_marka_docs}
                                                    </TableCell>
                                                    <TableCell>
                                                        {material.factory_manufacturer}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        {material.count.toFixed(2).replace('.', ',')} {material.unit}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        {material.mass > 0 ? material.mass.toFixed(2).replace('.', ',') : '-'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>
                                                        {(() => {
                                                            // Группируем объекты по типам
                                                            const grouped = {};
                                                            Array.from(material.objects).forEach(obj => {
                                                                // const [type, name] = obj.split(': ');
                                                                if (!grouped[obj[1]]) {
                                                                    grouped[obj[1]] = new Set();
                                                                }
                                                                grouped[obj[1]].add(obj[0]);
                                                            });

                                                            // Формируем строку с группировкой
                                                            return Object.entries(grouped).map(([typeName, names]) =>
                                                                `${typeName}: ${[...names].join(', ')}`
                                                            ).join('; ');
                                                        })()}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                            rowIndex++;
                                        });
                                    });

                                    return rows;
                                })()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}

            {/* Структурированный вид */}
            {tabValue === 1 && (
                <Box>
                    <Typography variant="h6" sx={{
                        mb: 2,
                        color: darkMode ? '#f5f7fa' : '#333',
                        fontWeight: 600
                    }}>
                        Спецификации ({specStats.length} позиций)
                    </Typography>

                    {specStats.map((item, index) => (
                        <Card key={index} sx={{
                            mb: 2,
                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                            borderRadius: 2,
                            boxShadow: darkMode
                                ? '0 2px 8px rgba(0,0,0,0.3)'
                                : '0 2px 8px rgba(0,0,0,0.1)'
                        }}>
                            <CardContent sx={{ p: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                    <Box>
                                        <Typography variant="h6" sx={{
                                            fontWeight: 600,
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            mb: 0.5
                                        }}>
                                            {item.spec.name}
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            color: darkMode ? '#bbb' : '#666',
                                            mb: 0.5
                                        }}>
                                            {item.spec.type_marka_docs}
                                        </Typography>
                                        <Typography variant="caption" sx={{
                                            color: darkMode ? '#999' : '#888'
                                        }}>
                                            {item.spec.category}
                                        </Typography>
                                    </Box>
                                    <Chip
                                        label={item.count}
                                        size="small"
                                        sx={{
                                            bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
                                            color: darkMode ? '#ce93d8' : '#9c27b0',
                                            fontWeight: 600
                                        }}
                                    />
                                </Box>

                                <Typography variant="body2" sx={{
                                    color: darkMode ? '#ccc' : '#555',
                                    mb: 1,
                                    fontWeight: 500
                                }}>
                                    {(() => {
                                        // Группируем объекты по типам
                                        const grouped = {};
                                        item.objects.forEach(obj => {
                                            // const [type, name] = obj.split(': ');
                                            if (!grouped[obj[1]]) {
                                                grouped[obj[1]] = [];
                                            }
                                            grouped[obj[1]].push(obj[0]);
                                        });

                                        // Формируем строку с группировкой
                                        return Object.entries(grouped).map(([type, names]) =>
                                            `${type}: ${[... new Set(names)].join(', ')}`
                                        ).join('; ');
                                    })()}
                                </Typography>

                                {/* Для фидеров показываем упрощенную таблицу */}
                                {item.typeName === 'Фидер' ? (
                                    <TableContainer sx={{
                                        maxHeight: 300,
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        borderRadius: 1,
                                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                    }}>
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                    }}>
                                                        Наименование
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                    }}>
                                                        Тип, марка
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                    }}>
                                                        Завод изготовитель
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        textAlign: 'center',
                                                        bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                    }}>
                                                        Количество пролетов
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        textAlign: 'center',
                                                        bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                    }}>
                                                        Общая длина, м
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{
                                                        fontSize: '0.75rem',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                    }}>
                                                        {item.spec.name}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontSize: '0.75rem',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                    }}>
                                                        {item.spec.type_marka_docs}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontSize: '0.75rem',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                    }}>
                                                        {item.spec.factory_manufacturer}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontSize: '0.75rem',
                                                        textAlign: 'center',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                    }}>
                                                        {item.count}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        fontSize: '0.75rem',
                                                        textAlign: 'center',
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                    }}>
                                                        {(() => {
                                                            // Вычисляем общую длину для всех фидеров этого типа
                                                            let totalLength = 0;
                                                            if (taskObjects.fiders) {
                                                                taskObjects.fiders.forEach(fider => {
                                                                    if (fider.spec === item.spec.id) {
                                                                        totalLength += (fider.chains.reduce((t, r) => t + r, 0) || 0) * (fider.distance || 0);
                                                                    }
                                                                });
                                                            }
                                                            return totalLength.toFixed(2).replace('.', ',');
                                                        })()}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    /* Для остальных объектов показываем стандартную таблицу */
                                    item.spec.complect_filtered && (
                                        <TableContainer sx={{
                                            maxHeight: 300,
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            borderRadius: 1,
                                            border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                        }}>
                                            <Table size="small" stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                        }}>
                                                            Наименование
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                        }}>
                                                            Тип, марка
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                        }}>
                                                            Завод изготовитель
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            textAlign: 'center',
                                                            bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                        }}>
                                                            Количество на единицу
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            textAlign: 'center',
                                                            bgcolor: darkMode ? '#333' : '#f5f5f5',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
                                                        }}>
                                                            Общее количество
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {item.spec.complect_filtered.map((cf, cfIndex) => (
                                                        <React.Fragment key={cfIndex}>
                                                            <TableRow>
                                                                <TableCell colSpan={5} sx={{
                                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.8rem',
                                                                    color: darkMode ? '#f5f7fa' : '#333',
                                                                    borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                }}>
                                                                    {cf.type}
                                                                </TableCell>
                                                            </TableRow>
                                                            {cf.complect.map((material, mIndex) => (
                                                                <TableRow key={mIndex}>
                                                                    <TableCell sx={{
                                                                        fontSize: '0.75rem',
                                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                    }}>
                                                                        {material.name}
                                                                    </TableCell>
                                                                    <TableCell sx={{
                                                                        fontSize: '0.75rem',
                                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                    }}>
                                                                        {material.type_marka_docs}
                                                                    </TableCell>
                                                                    <TableCell sx={{
                                                                        fontSize: '0.75rem',
                                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                    }}>
                                                                        {material.factory_manufacturer}
                                                                    </TableCell>
                                                                    <TableCell sx={{
                                                                        fontSize: '0.75rem',
                                                                        textAlign: 'center',
                                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                    }}>
                                                                        {parseFloat(material.count).toString().replace('.', ',')} {material.unit}
                                                                    </TableCell>
                                                                    <TableCell sx={{
                                                                        fontSize: '0.75rem',
                                                                        textAlign: 'center',
                                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                                                    }}>
                                                                        {(parseFloat(material.count) * item.count).toString().replace('.', ',')} {material.unit}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )
                                )}
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            )}
        </Box>
    );
};